import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  repo: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type GithubBranch = {
  name: string;
  protected: boolean;
};

export type OutputType = {
  branches: GithubBranch[];
  defaultBranch: string;
};

export const getGithubBranches = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ repo: input.repo });

  const result = await fetch(`/_api/github/branches?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
